import React from 'react';
import DynamicPracticePage from '../../components/common/DynamicPracticePage';
import { TopicItem } from '../../components/common/PracticeContentLayout';

// Define the HLD topic structure based on System Design Interview - An Insider's Guide
const topics: TopicItem[] = [
  {
    id: 'hld-introduction',
    title: 'HLD Introduction',
    completed: false,
    children: [
      { id: 'intro-1', title: 'What is High Level Design?', completed: false },
      { id: 'intro-2', title: 'HLD vs LLD', completed: false },
      { id: 'intro-3', title: 'System Design Interview Process', completed: false },
      { id: 'intro-4', title: 'Key Design Principles', completed: false },
    ],
  },
  {
    id: 'requirements-gathering',
    title: 'Requirements Gathering',
    completed: false,
    children: [
      { id: 'req-1', title: 'Functional Requirements', completed: false },
      { id: 'req-2', title: 'Non-Functional Requirements', completed: false },
      { id: 'req-3', title: 'Scale Estimation', completed: false },
      { id: 'req-4', title: 'User Stories & Use Cases', completed: false },
      { id: 'req-5', title: 'Constraints & Assumptions', completed: false },
    ],
  },
  {
    id: 'back-of-envelope',
    title: 'Back-of-the-Envelope Estimation',
    completed: false,
    children: [
      { id: 'est-1', title: 'Traffic Estimation', completed: false },
      { id: 'est-2', title: 'Storage Estimation', completed: false },
      { id: 'est-3', title: 'Bandwidth Estimation', completed: false },
      { id: 'est-4', title: 'Server Capacity Planning', completed: false },
      { id: 'est-5', title: 'Cost Estimation', completed: false },
    ],
  },
  {
    id: 'system-architecture',
    title: 'System Architecture Design',
    completed: false,
    children: [
      { id: 'arch-1', title: 'Monolithic Architecture', completed: false },
      { id: 'arch-2', title: 'Microservices Architecture', completed: false },
      { id: 'arch-3', title: 'Service-Oriented Architecture (SOA)', completed: false },
      { id: 'arch-4', title: 'Event-Driven Architecture', completed: false },
      { id: 'arch-5', title: 'Serverless Architecture', completed: false },
      { id: 'arch-6', title: 'Choosing the Right Architecture', completed: false },
    ],
  },
  {
    id: 'scalability-patterns',
    title: 'Scalability Patterns',
    completed: false,
    children: [
      { id: 'scale-1', title: 'Horizontal vs Vertical Scaling', completed: false },
      { id: 'scale-2', title: 'Load Balancing Strategies', completed: false },
      { id: 'scale-3', title: 'Database Scaling', completed: false },
      { id: 'scale-4', title: 'Caching Strategies', completed: false },
      { id: 'scale-5', title: 'CDN Implementation', completed: false },
      { id: 'scale-6', title: 'Message Queues for Scaling', completed: false },
    ],
  },
  {
    id: 'api-design',
    title: 'API Design',
    completed: false,
    children: [
      { id: 'api-1', title: 'REST API Design', completed: false },
      { id: 'api-2', title: 'GraphQL Design', completed: false },
      { id: 'api-3', title: 'gRPC Design', completed: false },
      { id: 'api-4', title: 'API Versioning', completed: false },
      { id: 'api-5', title: 'Rate Limiting', completed: false },
      { id: 'api-6', title: 'API Gateway Pattern', completed: false },
    ],
  },
  {
    id: 'database-design',
    title: 'Database Design',
    completed: false,
    children: [
      { id: 'db-1', title: 'SQL vs NoSQL Selection', completed: false },
      { id: 'db-2', title: 'Database Replication', completed: false },
      { id: 'db-3', title: 'Database Sharding', completed: false },
      { id: 'db-4', title: 'Consistent Hashing', completed: false },
      { id: 'db-5', title: 'Database Indexing Strategy', completed: false },
      { id: 'db-6', title: 'Data Partitioning', completed: false },
    ],
  },
  {
    id: 'caching-strategies',
    title: 'Caching Strategies',
    completed: false,
    children: [
      { id: 'cache-1', title: 'Caching Layers', completed: false },
      { id: 'cache-2', title: 'Cache-Aside Pattern', completed: false },
      { id: 'cache-3', title: 'Write-Through Cache', completed: false },
      { id: 'cache-4', title: 'Write-Behind Cache', completed: false },
      { id: 'cache-5', title: 'Cache Eviction Policies', completed: false },
      { id: 'cache-6', title: 'Distributed Caching', completed: false },
    ],
  },
  {
    id: 'load-balancing',
    title: 'Load Balancing',
    completed: false,
    children: [
      { id: 'lb-1', title: 'Load Balancer Types', completed: false },
      { id: 'lb-2', title: 'Load Balancing Algorithms', completed: false },
      { id: 'lb-3', title: 'Health Checks', completed: false },
      { id: 'lb-4', title: 'Session Persistence', completed: false },
      { id: 'lb-5', title: 'Geographic Load Balancing', completed: false },
    ],
  },
  {
    id: 'message-queues',
    title: 'Message Queues & Pub/Sub',
    completed: false,
    children: [
      { id: 'mq-1', title: 'Message Queue Basics', completed: false },
      { id: 'mq-2', title: 'Pub/Sub Pattern', completed: false },
      { id: 'mq-3', title: 'Message Queue vs Pub/Sub', completed: false },
      { id: 'mq-4', title: 'Message Ordering', completed: false },
      { id: 'mq-5', title: 'Message Durability', completed: false },
      { id: 'mq-6', title: 'Dead Letter Queues', completed: false },
    ],
  },
  {
    id: 'distributed-systems',
    title: 'Distributed Systems Concepts',
    completed: false,
    children: [
      { id: 'dist-1', title: 'CAP Theorem', completed: false },
      { id: 'dist-2', title: 'Consistency Models', completed: false },
      { id: 'dist-3', title: 'Consensus Algorithms', completed: false },
      { id: 'dist-4', title: 'Leader Election', completed: false },
      { id: 'dist-5', title: 'Distributed Transactions', completed: false },
      { id: 'dist-6', title: 'Quorum', completed: false },
    ],
  },
  {
    id: 'security-design',
    title: 'Security & Reliability',
    completed: false,
    children: [
      { id: 'sec-1', title: 'Authentication & Authorization', completed: false },
      { id: 'sec-2', title: 'Encryption at Rest & Transit', completed: false },
      { id: 'sec-3', title: 'DDoS Protection', completed: false },
      { id: 'sec-4', title: 'Fault Tolerance', completed: false },
      { id: 'sec-5', title: 'Circuit Breaker Pattern', completed: false },
      { id: 'sec-6', title: 'Idempotency', completed: false },
    ],
  },
  {
    id: 'monitoring-observability',
    title: 'Monitoring & Observability',
    completed: false,
    children: [
      { id: 'mon-1', title: 'Logging Strategy', completed: false },
      { id: 'mon-2', title: 'Metrics & Monitoring', completed: false },
      { id: 'mon-3', title: 'Distributed Tracing', completed: false },
      { id: 'mon-4', title: 'Alerting Systems', completed: false },
      { id: 'mon-5', title: 'Performance Monitoring', completed: false },
    ],
  },
  {
    id: 'trade-offs',
    title: 'Design Trade-offs',
    completed: false,
    children: [
      { id: 'trade-1', title: 'Consistency vs Availability', completed: false },
      { id: 'trade-2', title: 'Latency vs Throughput', completed: false },
      { id: 'trade-3', title: 'Cost vs Performance', completed: false },
      { id: 'trade-4', title: 'Simplicity vs Flexibility', completed: false },
      { id: 'trade-5', title: 'Monolith vs Microservices', completed: false },
    ],
  },
  {
    id: 'case-studies',
    title: 'HLD Case Studies',
    completed: false,
    children: [
      { id: 'case-1', title: 'Design a URL Shortener', completed: false },
      { id: 'case-2', title: 'Design a Web Crawler', completed: false },
      { id: 'case-3', title: 'Design a Rate Limiter', completed: false },
      { id: 'case-4', title: 'Design a Notification System', completed: false },
      { id: 'case-5', title: 'Design a News Feed System', completed: false },
    ],
  },
];

const HLDPractice: React.FC = () => {
  return (
    <DynamicPracticePage
      topicType="hld"
      topics={topics}
      title="Master High Level Design"
    />
  );
};

export default HLDPractice;


